<template>
  <div class="contacts" :style='{"background-image": "url("+APP_PATH+page.data.extras.background+")"}'>
    <div class="container fullscreen-content">
      <div class="contact-form">
        <div class="row">
          <div class="col-6 col-md-12">
            <h1 class="section-title with-line">{{page.data.title}}</h1>
            <div class="form-field">
              <label>{{$t('name')}}</label>
              <input
                type="text"
                v-validate="'required'"
                name="first-name"
                v-model="contact.name"
              />
              <span>{{ errors.first('first-name') }}</span>
            </div>
            <div class="form-field">
              <label>{{$t('email')}}</label>
              <input
                type="text"
                v-validate="'required|email'"
                name="email"
                v-model="contact.email"
              />
              <span>{{ errors.first('email') }}</span>
            </div>
            <div class="form-field">
              <label>{{$t('enquiry')}}</label>
              <textarea
                cols="30"
                rows="10"
                v-validate="'required'"
                name="message"
                v-model="contact.message"
              ></textarea>
              <span>{{ errors.first('message') }}</span>
            </div>
            <div class="form-field">
              <div v-if="msg!=false" class="form-msg">{{msg}}</div>
              <button class="button" :disabled="loading" :class="{loading: loading}"@click="send()">{{$t('submit')}}</button>
            </div>

            <div class="our-contacts">
              <ul>
                <li>
                  <label>Nush Enamel Jewelry</label>
                  <span>Yerevan, Armenia</span>
                </li>
                <li>
                  <label>Telephone</label>
                  <span>+374 99 21 80 76</span>
                </li>
                <li>
                  <label>Follow Us:</label>
                  <span>
                    <socials></socials>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/api-service';
import Socials from '@/components/global/Social.vue';
import { mapState } from 'vuex';

export default {
  name: 'contacts',
  components: {
    Socials
  },
  i18n: {
    messages: {
      en: {
        name: "Your name",
        email: "E-mail address",
        enquiry: "Enquiry",
        submit: "SUBMIT",
        success: 'Thank you for your message.',
        error: 'ERROR! Please try again'
      },
      hy: {
        name: "Անուն",
        email: "Էլ․ փոստ",
        enquiry: "Նամակ",
        submit: "ՈՒՂԱՐԿԵԼ",
        success: 'Շնորհակալություն՝ ձեր նամակը ուղարկված է։',
        error: 'Տեղի է ունեցել սխալ։ Փորձեք կրկին։'
      },
      ru: {
        name: "Имя",
        email: "Электронный адрес",
        enquiry: "Сообщение",
        submit: "ОТПРАВИТЬ",
        success: 'Спасибо, ваше сообщение отправлено',
        error: 'Ошибка. Попробуйте еще раз'
      }
    }
  },
  data () {
    return {
      loading: false,
      msg: '',
      status: '',
      contact: {
        name: '',
        email: '',
        message: '',
        link: this.$route.fullPath
      },
    }
  },
  methods: {
    send () {
      if (!this.loading) {
        this.msg = false
        this.$validator.validateAll().then(result => {
          if (result) {
            this.loading = true
            Api.post('/contact-us', { data: this.contact })
            .then(response => {
              this.loading = false
              this.backorder_popup = false
              if(response.data.status === 'success'){
                this.contact = {
                  name: '',
                  email: '',
                  phone: '',
                  message: ''
                }
                this.$validator.reset()
                this.msg = this.$t('success')
              }else{
                this.msg = this.$t('error')
              }
            })
            .catch(error => {
              this.loading = false
              this.msg = this.$t('error')
            })
          }
        })
      }
    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.contacts {
  padding-top: 130px;
  padding-bottom: 70px;
  background-color: #FEF9F2;
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;

  @include mq($ms){
    background-image: none!important;
    padding-top: 90px;
    padding-bottom: 40px;
  }

  .page-description {
    max-width: 500px;
    margin: auto;
    text-align: center;
    margin-bottom: 60px;
  }

  .contact-form {
    max-width: 1100px;
    margin: auto;
    .form-field {
      margin-bottom: 30px;
      position: relative;
      label{
        margin-top: 0;
        margin-bottom: 10px;
        display: block;
        font-family: $font-bold;
      }
      input, textarea{
        background: transparent;
        border: 1px solid #9E9E9E;
      }
      textarea {
        height: 122px;
        resize: none;
        padding-top: 15px;
      }
      .button {
        max-width: 250px;
      }
      span {
        position: absolute;
        bottom: -20px;
        right: 0;
      }
    }

    .form-msg{
      margin-bottom: 15px;
    }

    .our-contacts{
      margin-top: 50px;
      &>ul{
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
        li{
          max-width: 33.33333%;
          margin-bottom: 15px;
          label, span{
            display: block;
          }
          label{
            font-family: $font-bold;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
